import axios from 'axios';

/** API BFF: `{ data: RewardSet[] }` oppure array diretto. */
export const unwrapRewardSetsPayload = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

export const buildRewardImageByIdMap = (sets) => {
  const map = {};
  unwrapRewardSetsPayload(sets).forEach((set) => {
    (set.rewards || []).forEach((reward) => {
      if (reward.documentId && reward.image) {
        map[reward.documentId] = reward.image;
      }
    });
  });
  return map;
};

export const fetchRewardSets = async () => {
  const response = await fetch('/api/reward-sets');
  if (!response.ok) {
    throw new Error('Errore nel caricamento del catalogo premi');
  }
  return response.json();
};

/** Lista set premi (array), come usato in catalogo / eventi. */
export const fetchRewardSetsList = async () => {
  const payload = await fetchRewardSets();
  return unwrapRewardSetsPayload(payload);
};

export const fetchRewardSetBySlug = async (slug) => {
  const response = await fetch(`/api/reward-sets/${encodeURIComponent(slug)}`);
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('not-found');
    }
    throw new Error('Errore nel caricamento del set premi');
  }
  return response.json();
};

export const createRewardOrder = async (items) => {
  const response = await axios.post(
    '/api/rewards/order',
    { items },
    { withCredentials: true }
  );
  return response.data;
};
